import { ArrowTopRightOnSquareIcon } from '@heroicons/react/16/solid';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface ShareProps {
  url: string;
  title: string;
}

export function Share({ title, url }: ShareProps) {
  const { t } = useTranslation();
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: t('components.share.shareText'),
          url,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      await navigator.clipboard.writeText(url);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <Button
      variant='text'
      className='bg-transparent border-none shadow-none'
      onClick={handleShare}
    >
      <div className='flex text-wl-primary w-full sm:w-auto sm:text-right gap-2'>
        <span className='text-M-16'>{t('components.share.shareLink')}</span>
        <ArrowTopRightOnSquareIcon width={16} />
      </div>
    </Button>
  );
}
